import { defineRemoteFrame } from "./index";

/** Standalone entry that guarantees remote-frame registration for direct browser usage. */
defineRemoteFrame();
